import { render, staticRenderFns } from "./edit-create.vue?vue&type=template&id=108aef01"
import script from "./edit-create.vue?vue&type=script&lang=ts"
export * from "./edit-create.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0___ece59b1ed0110506a3a0f8f8739009f9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports